<template>
    <div class="setting-wrapper">
        <div class="setting">
            <h4 :class="h4Class">
                {{ title }}
            </h4>

            <!-- eslint-disable vue/no-v-html -->
            <div
                v-if="description && options.length > 1 && toggled"
                class="text-sm text-neutral-dark mb-lg md:mb-xl lg:hidden"
                v-html="description"
            />
            <div v-else-if="description">
                <a
                    :class="{ 'is-active' : toggled }"
                    class="absolute pin-t pin-r mt-xl lg:mt-5xl text-neutral-darker read-more lg:hidden"
                    tabindex="0"
                    @click="toggle"
                    @keydown.enter="toggle"
                >
                    <font-awesome-icon icon="chevron-down" class="chevron text-sm lg:text-lg" />
                </a>
                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-if="toggled"
                    class="text-sm text-neutral-dark mb-lg md:mb-xl lg:hidden"
                    v-html="description"
                />
            </div>

            <option-box-checkbox
                v-for="option in options"
                :key="option.name + option.value"
                :checked="checked"
                :name="option.name"
                :value="option.value"
                :disabled="disabled"
                :disabled-explanation="disabledExplanation"
                additional-class="option"
                @input="(data) => $emit('input', data)"
            >
                <span class="option-label">
                    {{ option.label }}

                    <span v-if="option.valuePrice" class="font-regular ml-auto md:ml-0">
                        {{ option.valuePrice }}
                    </span>
                </span>
            </option-box-checkbox>

            <!-- eslint-disable vue/no-v-html -->
            <div
                v-if="description && options.length === 1"
                class="ml-auto text-sm text-neutral-dark lg:w-3/5 hidden lg:block"
                v-html="description"
            />
        </div>
        <div v-if="description && options.length > 1">
            <a
                class="absolute pin-t pin-r mt-xl lg:mt-5xl text-neutral-darker read-more"
                :class="{ 'is-active' : toggled }"
                tabindex="0"
                @click="toggle"
                @keydown.enter="toggle"
            >
                <font-awesome-icon icon="chevron-down" class="chevron text-sm lg:text-lg" />
            </a>
            <div v-if="toggled" class="ml-auto pb-2xl w-4/5 text-sm text-neutral-dark hidden lg:block">
                <!-- eslint-disable vue/no-v-html -->
                <div v-html="description" />
            </div>
        </div>
    </div>
</template>

<script>
    import CheckboxEvent from '../../../Atlantis/Forms/CheckboxEvent';

    export default {
        mixins: [CheckboxEvent],
        model: {
            prop: 'checked',
            event: 'input',
        },
        props: {
            layout: {
                type: String,
                default: 'big',
            },
            description: {
                required: false,
                type: String,
                default: null,
            },
            title: {
                required: true,
                type: String,
            },
            options: {
                required: true,
                type: Array,
            },
            checked: {
                required: true,
                type: [Boolean, Array],
            },
            disabled: {
                type: Boolean,
                default: null,
            },
            disabledExplanation: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                toggled: false,
            };
        },
        computed: {
            h4Class() {
                return this.layout === 'small' ? 'lg:w-1/5 mr-xl' :  'lg:w-1/5';
            },
        },
        methods: {
            toggle() {
                this.toggled = ! this.toggled;
            },
        },
    };
</script>
